module.exports = __webpack_public_path__ + "img/9788995574720.85bd6e93.jpg";